import { render, staticRenderFns } from "./UILayers.vue?vue&type=template&id=13d3e26d&scoped=true&"
import script from "./UILayers.vue?vue&type=script&lang=js&"
export * from "./UILayers.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/ui.css?vue&type=style&index=0&id=13d3e26d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d3e26d",
  null
  
)

export default component.exports